import { Component, Input, OnInit } from '@angular/core';
import { Sbmessage } from '@models';

@Component({
    selector: 'app-sb-messages',
    templateUrl: './sb-messages.component.html'
})
export class SbMessagesComponent implements OnInit {
    @Input() messages: Sbmessage[];

    constructor() {}

    ngOnInit(): void {}

    getMessageIconsAndColor(message) {
        if (message.severity === 'error') {
            return { color: 'critical', icon: 'error_outline' };
        } else if (message.severity === 'success') {
            return { color: 'success', icon: 'check_circle_outline' };
        } else if (message.severity === 'warning') {
            return { color: 'warning', icon: 'report_problem' };
        } else {
            return { color: 'info', icon: 'info' };
        }
    }
}
